import React, { useState, useEffect } from 'react';
import axios from "./axios";
import { useParams, useNavigate, useLocation } from 'react-router-dom';
import Header from './Header';
import Footer from './Footer';
import Wrapper from './Wrapper';
import EventSection from './EventSection';
import FeaturedEvents from './FeaturedEvents';
import CampingEventSection from './CampingEventSection';
import NewsLetter from './NewsLetter';
import CategorySection from './CategorySection';
import TestimonialBannerShippingSection from './TestimonialBannerShippingSection';
import Banner from './Banner';
import LoaderImg from './img/logo/running.gif'
import UpcomingEvent from './UpcomingEvent'
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import RegistrationEventSection from './RegistrationEventSection';
import { token } from "./features/TokenSlice";
import { useDispatch } from "react-redux";

const Home = (props) => {
  const { reset_password } = useParams();
  const { reset_password_token } = useParams();
  // console.log(reset_password, reset_password_token);

  const { login_as_org } = useParams();
  const { user_email } = useParams();
  const { user_pass } = useParams();

  // console.log(login_as_org);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [add, setAdd] = useState([]);
  const [EventsData, setEventsData] = useState([]);
  // const [CityData, setCityData] = useState([]);
  const [BannerImages, setBannerImages] = useState([]);

  const UserAddress = localStorage.getItem("UserAddress");

  const [HeaderInputCity, setHeaderInputCity] = useState('');
  const [CityName, setCityName] = useState(localStorage.getItem("City") ? localStorage.getItem("City") : "");
  // console.log(CityName);
  const [CountryName, setCountryName] = useState('');

  const [CountrySearchFlag, setCountrySearchFlag] = useState(false);
  const [CitySearchFlag, setCitySearchFlag] = useState(false);

  const [SearchFlag, setSearchFlag] = useState('');
  const [EventSearch, setEventSearch] = useState('');
  const [EventNameSearch, setEventNameSearch] = useState('');
  const [SearchEventPageFlag, setSearchEventPageFlag] = useState(localStorage.getItem("SearchEventPageFlag") ? localStorage.getItem("SearchEventPageFlag") : "");

  const [Loader, setLoader] = useState(false);

  const [FewSuggestionFlag, setFewSuggestionFlag] = useState(0);

  const [EventViewFlag, setEventViewFlag] = useState(localStorage.getItem("EventViewFlag"));
  // const [EventDetailsId, setEventDetailsId] = useState('');
// console.log(EventViewFlag, SearchEventPageFlag);
  const [LoginWishlist, setLoginWishlist] = useState(false);
  const [CategoryFilter, setCategoryFilter] = useState('');
  const [QuicklyFilter, setQuicklyFilter] = useState('');
  const [BannerBackgroundImg, setBannerBackgroundImg] = useState('');
  const [UpcomingEventsData, setUpcomingEventsData] = useState([]);
  const [RegistrationEventData, setRegistrationEventData] = useState([]);
  const [FeaturedEventData, setFeaturedEventData] = useState([]);
  const [CampingEventData, setCampingEventData] = useState([]);
  const [LoginFlag, setLoginFlag] = useState(false);
  const [ApiCall, setApiCall] = useState(true);
  const [CategoryData, setCategoryData] = useState([]);
  const [EventCountData, setEventCountData] = useState([]);
  // const [WishListFlag, setWishListFlag] = useState(false);
  const [CountryFlag, setCountryFlag] = useState(false);
  //FROM SEARCH EVENTS PAGE VIEW CLICK  && FROM REGISTER NOW PAGE && VIEW ORGANIZER PAGE
  const [UrlCityLoadFlag, setUrlCityLoadFlag] = useState(true);
  const [UrlCity, setUrlCity] = useState('');
  const [UrlCityId, setUrlCityId] = useState('');
  const location = useLocation();
  const { country } = useParams();

  const AppLoginFlag = localStorage.getItem("AppLogin") ? localStorage.getItem("AppLogin") : "";

  useEffect(() => {
    if (location.state) {
      if (location.state.reset_pwd) {
        // console.log("here")
      }
    }
  }, [location.state])

  // console.log(HeaderInputCity);
    useEffect(() => {
      if (ApiCall || HeaderInputCity) {
        const payload = {
          country: localStorage.getItem("CountryId") ? localStorage.getItem("CountryId") : "",
          city: HeaderInputCity ? HeaderInputCity : "",
        }
        axios.post('getCategoryEventsCount',payload)
            .then((response) => {
                // console.log(response.data.data);
                if (response.status === 200) {
                    setApiCall(false);
                    setCategoryData(response.data.data.category_data);
                    setEventCountData(response.data.data);
                }
            })
            .catch((error) => {
                console.log(error);
            })
      }
    }, [ApiCall,HeaderInputCity])
    // console.log(CategoryData);

  //FROM SEARCH EVENTS PAGE WISHLIST CLICK
  // const location = useLocation();
  useEffect(() => {
    if (location.state) {
      if (location.state.login_popup) {
        setLoginWishlist(true);
        //  navigate('/events')
      }
    }
  }, [location.state])
 
  localStorage.removeItem("BookTicketEventId");

  // console.log(WishListFlag);
  // INITIALLY SHOWS PAGE BLANK ON PRIME
   //-------- get banner
  useEffect(() => {
    if ((location.state === 'null' && !CountrySearchFlag && SearchFlag === "")) {
      localStorage.removeItem("SearchEventPageFlag");

      const CountryCode = localStorage.getItem("CountryCode") ? localStorage.getItem("CountryCode") : "in";
      const Country = localStorage.getItem("Country") ? localStorage.getItem("Country") : "India";
      const State = localStorage.getItem("StateId") ? localStorage.getItem("StateId") : "";
      const City = localStorage.getItem("City") ? localStorage.getItem("City") : "";
      //  setLoader(true);
      const payload = {
        country: Country,
        country_code: CountryCode,
        city: City,
        state: State,
        scity: localStorage.getItem("CityId") ? localStorage.getItem("CityId") : "",
        sstate: localStorage.getItem("StateId") ? localStorage.getItem("StateId") : "",
        scountry: localStorage.getItem("CountryId") ? localStorage.getItem("CountryId") : "",
        home_flag: 1
      }
     
      axios.post("get_banner_events", payload)
        .then((response) => {
          // console.log(response.data.data);
          localStorage.setItem("MAX_UPLOAD_FILE_SIZE", response.data.data.MAX_UPLOAD_FILE_SIZE)
          setFewSuggestionFlag(response.data.FewSuggestionFlag);
          localStorage.setItem("CountryId", response.data.data.CountryId);
          localStorage.setItem("StateId", response.data.data.StateId);
          localStorage.setItem("CityId", response.data.data.CityId);
          // console.log(response.data.data.CityName,Country);
          if (City === '' || City === undefined) {
            setCountryName(Country);
            navigate("/" + CountryCode + "/" + Country);
          } else {
            setCityName(response.data.data.CityName);
            navigate("/" + CountryCode + "/" + response.data.data.CityName);
          }
          setCountrySearchFlag(false);
          
          setEventsData(response.data.data.eventData);
          setRegistrationEventData(response.data.data.RegistrationEventData);
          setFeaturedEventData(response.data.data.FeaturedEventData);
          setCampingEventData(response.data.data.CampingEventData);
          setBannerImages(response.data.data.BannerImages);
          setBannerBackgroundImg(response.data.data.eventData[0].background_image);
          setUrlCityId(0);
          setSearchFlag('HeaderInputCity')
          setLoader(false);
        })
        .catch((error) => {
          console.log(error);
        })
    }
  }, [CountrySearchFlag, SearchFlag, location.state, navigate])

  // GET CURRENT LOCATION 
  useEffect(() => {
    if (UserAddress === null) {
      // console.log("useEffect of GET CURRENT LOCATION");
      setLoader(true);
      navigator.geolocation.getCurrentPosition(pos => {
        const { latitude, longitude } = pos.coords;
        // console.log(latitude, longitude)
        const url = `https://nominatim.openstreetmap.org/reverse?format=json&lat=${latitude}&lon=${longitude}`;
        fetch(url)
          .then(res => res.json())
          .then(data => {
            setAdd(data.address); setCountrySearchFlag(true);
            localStorage.setItem("LocationFlag", 1);
          }
          )
      }, (error) => {
        // console.log(error);
        setAdd({ country_code: "in", country: "India" });
        setCountrySearchFlag(true);
        localStorage.setItem("LocationFlag", 0);
      })
    }
  }, [UserAddress])


  // FIRST API CALL WHILE AUTO LOCATION DETECT
  // console.log(CountrySearchFlag);
  //-------- get banner
  useEffect(() => {
    if (CountrySearchFlag) {
      // console.log('aa');
      setLoader(true);
      var address = [];
      address = add;
      // console.log(add);
      if (add) {
        localStorage.setItem("UserAddress", JSON.stringify({ add }));
      }
      else {
        address = JSON.parse(localStorage.getItem("UserAddress"));
      }

      const CountryCode = (address.country_code) ? address.country_code : "in";
      const Country = address.country ? address.country : "India";
      const State = address.state ? address.state : "";
      const City = address.city ? address.city : "";
      // console.log(add);
      //SET NAME OF COUNTRY,STATE AND CITY
      localStorage.setItem("Country", Country);
      localStorage.setItem("CountryCode", CountryCode);
      localStorage.setItem("State", State);
      localStorage.setItem("City", City);

      //SET ID OF COUNTRY,STATE AND CITY
      localStorage.setItem("CountryId", 0);
      localStorage.setItem("StateId", 0);
      localStorage.setItem("CityId", 0);

      const payload = {
        country: Country,
        country_code: CountryCode,
        city: City,
        state: State,
        // filter: CategoryFilter,
        scity: localStorage.getItem("CityId"),
        sstate: localStorage.getItem("StateId"),
        scountry: localStorage.getItem("CountryId"),
        home_flag: 1
      }
      // console.log(payload);
      axios.post("get_banner_events", payload)
        .then((response) => {
          // console.log(response.data.data.BannerImages);
          localStorage.setItem("MAX_UPLOAD_FILE_SIZE", response.data.data.MAX_UPLOAD_FILE_SIZE)
          setFewSuggestionFlag(response.data.FewSuggestionFlag);
          localStorage.setItem("CountryId", response.data.data.CountryId);
          localStorage.setItem("StateId", response.data.data.StateId);
          localStorage.setItem("CityId", response.data.data.CityId);
          // console.log(response.data.data.CityName,Country);
          if (City === '' || City === undefined) {
            // console.log("if");
            setCountryName(Country);
            navigate("/" + CountryCode + "/" + Country);
          } else {
            // console.log("else");
            setCityName(response.data.data.CityName);
            navigate("/" + CountryCode + "/" + response.data.data.CityName);
          }
          // console.log(response.data.data);
          setCountrySearchFlag(false);
          
          setEventsData(response.data.data.eventData);
          setRegistrationEventData(response.data.data.RegistrationEventData);
          setUpcomingEventsData(response.data.data.UpcomingEventData);
          setFeaturedEventData(response.data.data.FeaturedEventData);
          setCampingEventData(response.data.data.CampingEventData);
          // setCityData(response.data.data.cityData);
          setBannerImages(response.data.data.BannerImages);
          setBannerBackgroundImg(response.data.data.eventData[0].background_image);
          // setUrlCityId(0);
          setSearchFlag('HeaderInputCity')
          setLoader(false);
        })
        .catch((error) => {
          console.log(error);
          setLoader(false);
        })
    }
  }, [add, navigate, CountrySearchFlag])
  
  //--------- new added
  // console.log(UrlCityLoadFlag);
  useEffect(() => {
    if(country){
      // console.log(HeaderInputCity);
      //  setHeaderInputCity(0);
        axios.post("location_city", {
            'country_code': localStorage.getItem('CountryCode')
        })
        .then((response) => {
          const cityData = response.data.data.AllCities;
          const result = cityData.find(city =>
            Number(HeaderInputCity)
              ? city.id === Number(HeaderInputCity)
              : city.name.toLowerCase() === country.toLowerCase()
          );
          // console.log(result);
          if(result){
            localStorage.setItem("City", result.name);
            localStorage.setItem("CityId", result.id);
            localStorage.setItem("StateId", result.state_id);
            setUrlCityId(result.id); setUrlCity(result.name)
            setUrlCityLoadFlag(false);
           // SearchFlag === 'HeaderInputCity' &&
            if( country !== 'India'){
              setHeaderInputCity(result.id);
            }
          }
        })
        .catch((error) => {
            console.log(error);
        })
    }   
  }, [country, HeaderInputCity])

  // console.log(UrlCityId, SearchFlag, HeaderInputCity, country);  // get_data_location_wise
  useEffect(() => {
    if (SearchFlag === 'HeaderInputCity' || UrlCityId) {
      // console.log(HeaderInputCity, UrlCityId);
      // setLoader(true);
      let payload = {}
      if(CountryFlag){
          payload = {
            city: CountryFlag ? 0 : HeaderInputCity || CountryFlag ? 0 : localStorage.getItem("CityId"),
            // city: localStorage.getItem("CityId"),
            search_flag: SearchFlag,
            scity: localStorage.getItem("CityId"),
            state: localStorage.getItem("StateId"),
            country: localStorage.getItem("CountryId"),
            home_flag: 1
          }
      }else{
        payload = {
            city: HeaderInputCity || localStorage.getItem("CityId"),
            // city: localStorage.getItem("CityId"),
            search_flag: SearchFlag,
            scity: localStorage.getItem("CityId"),
            state: localStorage.getItem("StateId"),
            country: localStorage.getItem("CountryId"),
            home_flag: 1
        }
      }
       
      // console.log(CountryFlag);
      axios.post("get_data_location_wise", payload)
        .then((response) => {
          
          localStorage.setItem("MAX_UPLOAD_FILE_SIZE", response.data.data.MAX_UPLOAD_FILE_SIZE)
          setFewSuggestionFlag(response.data.FewSuggestionFlag);

          const CityName = response.data.data.CityName;
          const CountryCode = localStorage.getItem("CountryCode");
          const Country = localStorage.getItem("Country");
          // console.log(CityName,CountryCode,Country,HeaderInputCity);
          if (CityName !== "")
            setCityName(CityName);
          else
            setCityName(Country);

          localStorage.setItem("City", CityName);
          localStorage.setItem("CountryId", response.data.data.CountryId);
          localStorage.setItem("StateId", response.data.data.StateId);
          localStorage.setItem("CityId", response.data.data.CityId);
          // console.log(CityName);
          if (HeaderInputCity !== '' && CityName !== '') navigate("/" + CountryCode + "/" + CityName);
          setLoader(false);
          setSearchFlag('');
          setEventsData(response.data.data.eventData);
          setUpcomingEventsData(response.data.data.UpcomingEventData);
          setRegistrationEventData(response.data.data.RegistrationEventData);
          setFeaturedEventData(response.data.data.FeaturedEventData);
          setCampingEventData(response.data.data.CampingEventData);
          setBannerImages(response.data.data.BannerImages);
          setBannerBackgroundImg(response.data.data.eventData[0].background_image);
          // setWishListFlag(true);
          setCountryFlag(false);
        })
        .catch((error) => {
          console.log(error);
          setLoader(false);
        })
    }
  }, [navigate, HeaderInputCity, SearchFlag])

  // console.log(UpcomingEventsData); navigate, 
  // ------------------------------------------------------------------------------------------------
  const [isVisible, setIsVisible] = useState(false);

  // Function to handle scroll event and toggle button visibility
  const handleScroll = () => {
    const scrollY = window.scrollY;
    if (scrollY > 300) {
      setIsVisible(true);
    } else {
      setIsVisible(false);
    }
  };

  // Function to handle smooth scroll to top
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  // Add scroll event listener when component mounts
  React.useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  //-------------- new added for login as Organiser ,
  // 1 - Admin through login / 5 - Mobile App through login
  useEffect(() => {
    if (login_as_org && (login_as_org === '1' || login_as_org === 1) || (login_as_org === '5' || login_as_org === 5) ) {
        //--------------- Logout privious user
        localStorage.removeItem("Token");
        localStorage.removeItem("Name");
        localStorage.removeItem("Modules");
        localStorage.removeItem("Id");
        localStorage.removeItem("booking_pay_id");
        localStorage.removeItem("RacesToken");
        localStorage.removeItem("BookTicketEventId");
        localStorage.removeItem("AppLogin");
        dispatch(token(""));
        setLoginFlag(true);  
    }
  }, [login_as_org])
  
  // console.log(login_as_org);
 
  // console.log('LoginFlag'+LoginFlag); && AppLoginFlag == ""
  useEffect(() => {
    if (LoginFlag && AppLoginFlag == "") {
      setLoader(true);
      const payload = {
        "Email": user_email,
        "Password": user_pass ? user_pass : '',
        "LoginType": 1,
        "LoginAsOrganiser": 1,
        "AppLoginFlag": 5
      }
      //  console.log(payload)
      axios.post("login",payload)
      .then((response) => {
        // console.log(response)
        if (response.data.status === 200) {
          // console.log(response.data.user_id);
          if (parseInt(response.data.validate) === 0) {
            // console.log("validate is 0");
           // props.setMsgFlag("Login");
            localStorage.setItem(
              "RacesToken",
              JSON.stringify({ token: response.data.data.token })
            );

            localStorage.setItem("ID", response.data.data.userData.id)
            // localStorage.setItem("EMAIL", response.data.data.userData.email)
            // localStorage.setItem("MOBILE", response.data.data.userData.mobile)

            if(response.data.data.OrgUserAccessModules){
              localStorage.setItem("OrgUserAccessModules", JSON.stringify(response.data.data.OrgUserAccessModules));
              localStorage.setItem("LoginAsOrganiser", response.data.data.userData.organizer_user)
            } 
            localStorage.setItem("Access_Right_Flag", response.data.data.AccessRightFlag);

            dispatch(token({ token: response.data.data.token }));

            toast.success(response.message);
              // props.setOpen(false);
              // props.setLoginWishlist(false);
              // props.setWelcome(true);
              // if (props.Login)
              //   props.setLogin(false)
              if(login_as_org == 5){
                localStorage.setItem("AppLogin", 5);
              }
              navigate("/in/India", { replace: true });
            } else {
                localStorage.setItem("ID", response.data.user_id)
                navigate("/in/India", { replace: true });
            }
            setLoginFlag(false); 
            setLoader(false); 
            
        }
      })
      .catch((response) => {
        // console.log(response);
        // if (response.response.data.status === 400) {
        //   setErrFlag(true);
        //   setError(response.response.data.message);
        // }
        setLoader(false);
      });

      if(login_as_org == 1){
        localStorage.setItem("AdminLoginAsOrg", login_as_org);
        localStorage.setItem("LoginAsOrganiser", login_as_org);
      }
    }
  }, [LoginFlag])

  //------------------- End --------------------------
  // console.log(CountryFlag);

  // console.log(EventDetailsId,EventViewFlag,SearchEventPageFlag);
  return (
    <>
      <ToastContainer theme="colored" />
      {Loader ? <div><div id='loader' style={{ backgroundImage: `url(${LoaderImg})` }}></div></div> : null}

     
        <Header ResetPasswordFlag={reset_password} ResetPasswordToken={reset_password_token} setHeaderInputCity={setHeaderInputCity} setSearchFlag={setSearchFlag} HeaderInputCity={HeaderInputCity} CityName={CityName} CountryName={CountryName} setEventSearch={setEventSearch} setEventNameSearch={setEventNameSearch} SearchFlag={setSearchFlag} setEventsData={setEventsData} setLoginWishlist={setLoginWishlist} LoginWishlist={LoginWishlist} setCountrySearchFlag={setCountrySearchFlag} setEventViewFlag={setEventViewFlag} setSearchEventPageFlag={setSearchEventPageFlag} setQuicklyFilter={setQuicklyFilter} setCategoryFilter={setCategoryFilter} login_as_org={login_as_org} user_email={user_email} setCountryFlag={setCountryFlag} CountryFlag={CountryFlag}/>
     

      <main className="main__content_wrapper section-with-bg">

        {/* {EventViewFlag && !SearchEventPageFlag ? <EventDetails EventDetailsId={EventDetailsId} EventViewFlag={EventViewFlag} setEventViewFlag={setEventViewFlag} setCityName={setCityName} setLoginWishlist={setLoginWishlist} setCountrySearchFlag={setCountrySearchFlag} /> : null} */}



        {(!EventViewFlag && !SearchEventPageFlag) ? <Banner BannerImages={BannerImages} BannerBackgroundImg={BannerBackgroundImg} /> : null}
        
        {/* --------- Featured Events --------- */}
        {(!EventViewFlag && !SearchEventPageFlag) ? <FeaturedEvents FeaturedEventData={FeaturedEventData} FewSuggestionFlag={FewSuggestionFlag} ResetPasswordFlag={reset_password} ResetPasswordToken={reset_password_token} setHeaderInputCity={setHeaderInputCity} setSearchFlag={setSearchFlag} HeaderInputCity={HeaderInputCity} CityName={CityName} CountryName={CountryName} SearchFlag={setSearchFlag} setFeaturedEventData={setFeaturedEventData} setEventViewFlag={setEventViewFlag} setLoginWishlist={setLoginWishlist} setCityName={setCityName} setCountrySearchFlag={setCountrySearchFlag} CategoryData={CategoryData} setCountryFlag={setCountryFlag} /> : null}
        
        {/* --------- Recently Added Events --------- */}
        {(!EventViewFlag && !SearchEventPageFlag) ? <EventSection Events={EventsData} FewSuggestionFlag={FewSuggestionFlag} ResetPasswordFlag={reset_password} ResetPasswordToken={reset_password_token} setHeaderInputCity={setHeaderInputCity} setSearchFlag={setSearchFlag} HeaderInputCity={HeaderInputCity} CityName={CityName} CountryName={CountryName} SearchFlag={setSearchFlag} setEventsData={setEventsData} setEventViewFlag={setEventViewFlag} setLoginWishlist={setLoginWishlist} setCityName={setCityName} setCountrySearchFlag={setCountrySearchFlag} CategoryData={CategoryData} setCountryFlag={setCountryFlag} /> : null}
        
        {/* --------- Camping Events --------- */}
        {/* {(!EventViewFlag && !SearchEventPageFlag) ? <CampingEventSection Events={CampingEventData} FewSuggestionFlag={FewSuggestionFlag} ResetPasswordFlag={reset_password} ResetPasswordToken={reset_password_token} setHeaderInputCity={setHeaderInputCity} setSearchFlag={setSearchFlag} HeaderInputCity={HeaderInputCity} CityName={CityName} CountryName={CountryName} SearchFlag={setSearchFlag} setEventsData={setEventsData} setEventViewFlag={setEventViewFlag} setLoginWishlist={setLoginWishlist} setCityName={setCityName} setCountrySearchFlag={setCountrySearchFlag} CategoryData={CategoryData} setCountryFlag={setCountryFlag} /> : null} */}

        {/* --------- Upcoming Event --------- */}
        {((!EventViewFlag && !SearchEventPageFlag)) ? <UpcomingEvent UpcomingEvents={UpcomingEventsData} FewSuggestionFlag={FewSuggestionFlag} ResetPasswordFlag={reset_password} ResetPasswordToken={reset_password_token} setHeaderInputCity={setHeaderInputCity} setSearchFlag={setSearchFlag} HeaderInputCity={HeaderInputCity} CityName={CityName} CountryName={CountryName} setEventSearch={setEventSearch} setEventNameSearch={setEventNameSearch} SearchFlag={SearchFlag} setUpcomingEventsData={setUpcomingEventsData} setEventViewFlag={setEventViewFlag} setLoginWishlist={setLoginWishlist} setCityName={setCityName} setCountrySearchFlag={setCountrySearchFlag} EventCountData={EventCountData} CategoryData={CategoryData} setCountryFlag={setCountryFlag} /> : null}

    
        {((!EventViewFlag) && !SearchEventPageFlag) ? <CategorySection QuicklyFilter={QuicklyFilter} setQuicklyFilter={setQuicklyFilter} CategoryFilter={CategoryFilter} setCategoryFilter={setCategoryFilter} setCountrySearchFlag={setCountrySearchFlag} setHeaderInputCity={setHeaderInputCity} setSearchFlag={setSearchFlag} setSearchEventPageFlag={setSearchEventPageFlag} /> : null}

        {/* {!SearchEventPageFlag ? <NewsLetter /> : null} */}

        {(!EventViewFlag && !SearchEventPageFlag) ? <TestimonialBannerShippingSection /> : null}

      </main>

      {/* <Footer setEventViewFlag={setEventViewFlag} setCountrySearchFlag={setCountrySearchFlag} setSearchFlag={setSearchFlag} setEventSearch={setEventSearch} EventNameSearch={EventNameSearch} setEventNameSearch={setEventNameSearch} CategoryFilter={CategoryFilter} setCategoryFilter={setCategoryFilter} QuicklyFilter={QuicklyFilter} setQuicklyFilter={setQuicklyFilter} setSearchEventPageFlag={setSearchEventPageFlag} /> */}
      <Footer />
      <Wrapper />

      {/* Scroll top bar */}
      {isVisible ?
        <button
          aria-label="Scroll to top"
          id="scroll__top"
          className={isVisible ? 'show' : 'hide'}
          onClick={scrollToTop}
        >
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="48" height="48" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M12 19V5M5 12l7-7 7 7" />
          </svg>
        </button>
        : null}
    </>
  )
}

export default Home